export const getRandomKey = () => {
    return `${parseInt(`${Math.random() * 1000000}`, 36)}`;
};


// WEBPACK FOOTER //
// ./src/utils/index.js